/* Boteane About page — gentle reveal on scroll.
   Progressive enhancement only: without JS (or with reduced motion)
   every element stays fully visible. */
(function () {
  'use strict';

  // Each About section references this script; run once per page.
  if (window.__boteaneAboutInit) return;
  window.__boteaneAboutInit = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var elements = document.querySelectorAll('[data-ba-reveal]');
  if (!elements.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ba-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  elements.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    // Elements already in view on load stay visible — no pop-in.
    if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) return;
    el.classList.add('ba-will-reveal');
    observer.observe(el);
  });
})();
